import React from 'react';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
export function Experience() {
  return <section className="py-20 md:py-32 px-6 md:px-12 bg-cream relative" data-id="element-35" data-mp="23rkknictbi08">
      <div className="max-w-6xl mx-auto" data-id="element-36" data-mp="1yszl7l5dx2cu">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-37" data-mp="1yu0vhnektkti">
          {/* Text */}
          <div className="order-2 lg:order-1" data-id="element-38" data-mp="1tw93ktdxlypb">
            <FadeIn data-id="element-39" data-mp="2riq0vymo0cb2">
              <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-6" data-id="element-40" data-mp="2rgvfkj7hei6g">
                The Experience
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-41" data-mp="2hjqsmh5taiol">
              <h2 className="font-serif text-4xl md:text-5xl text-pine mb-8 leading-tight" data-id="element-42" data-mp="2hipeu4xevi36">
                Come for the heat, the cold, the fire, the music, and the quiet.
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-43" data-mp="166evep4k4ybe">
              <p className="text-lg text-clay font-light leading-relaxed mb-10" data-id="element-44" data-mp="162hbi1a5o2qg">
                Pines Retreat is a place to gather, reset, and return to
                yourself — whether for a workshop, private event, men's sauna
                night, or overnight stay.
              </p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-45" data-mp="jrbufvm3jc3u">
              <ul className="space-y-4 text-pine/90 font-light" data-id="element-46" data-mp="jq1v733ibxvm">
                <li className="flex items-center gap-4" data-id="element-47" data-mp="opwjcyvwe9cz">
                  <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-48" data-mp="oobplbhequg6" />
                  Wood-fired sauna & ice baths
                </li>
                <li className="flex items-center gap-4" data-id="element-49" data-mp="fp85q5af2b0m">
                  <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-50" data-mp="fqt09uwqdtyh" />
                  Fire & music gatherings
                </li>
                <li className="flex items-center gap-4" data-id="element-51" data-mp="5zonn1uj2l6t">
                  <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-52" data-mp="606okbs4xnl2" />
                  Geodesic dome & outdoor kitchen
                </li>
                <li className="flex items-center gap-4" data-id="element-53" data-mp="3s6vh2bs9hw9x">
                  <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-54" data-mp="3s6dgx42haxwq" />
                  Deep nature immersion
                </li>
              </ul>
            </FadeIn>
          </div>

          {/* Image Collage */}
          <div className="order-1 lg:order-2 relative h-[60vh] lg:h-[80vh] w-full" data-id="element-55" data-mp="1tvcy448j84fg">
            <FadeIn className="absolute inset-0 z-10" delay={0.2} data-id="element-56" data-mp="1oymj7k8grevm">
              <SafeImage src="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" alt="Fire pit burning beside the sauna at night" className="w-[85%] h-[75%] object-cover rounded-sm shadow-2xl" data-id="element-57" data-mp="1k0b8z8e9b2cv" />
            </FadeIn>

            <FadeIn className="absolute bottom-0 right-0 z-20 w-[65%] h-[55%]" delay={0.4} data-id="element-58" data-mp="w9xny1u3a3rs">
              <SafeImage src="https://cdn.magicpatterns.com/uploads/2R6iFsj5APGTGwRYAVkiFK/470801593_122128867442570946_8740882224121444447_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" alt="Ice bath at night surrounded by forest" className="w-full h-full object-cover rounded-sm shadow-2xl border-4 border-cream" data-id="element-59" data-mp="s6so671e8g6u" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}